// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorScreen_root__Z66O_","main":"ErrorScreen_main__wJJVF","image":"ErrorScreen_image__DtUrV","btn":"ErrorScreen_btn__kgb0z"};